import { Dimension, ResponsiveDimension } from "../../../types";

export type AvatarSize = "xsmall" | "small" | "medium" | "large";
export type AvatarState = "default" | "outline" | "selected";

export type AvatarImageWidthAndHeight = "16px" | "22px" | "32px" | "44px";
export type AvatarWidthAndHeight = "24px" | "32px" | "48px" | "64px";
export type SecondaryCircleWidthAndHeight = "11px" | "13px" | "18px" | "26px";

export type AvatarFormat = "avatarOnly" | "withButton" | "withIcon";

type AvatarStyles = {
  widthAndHeight: AvatarWidthAndHeight;
  imageSize: AvatarImageWidthAndHeight;
  insetAndBorderWidth: Dimension;
  secondaryCircleSize: SecondaryCircleWidthAndHeight;
  secondaryCirclePadding: ResponsiveDimension;
};

export const avatarSizeToStylesMap: {
  [key in AvatarSize]: AvatarStyles;
} = {
  xsmall: {
    widthAndHeight: "24px",
    imageSize: "16px",
    insetAndBorderWidth: "xxxsmall",
    secondaryCircleSize: "11px",
    secondaryCirclePadding: "xxsmall"
  },
  small: {
    widthAndHeight: "32px",
    imageSize: "22px",
    insetAndBorderWidth: "xxxsmall",
    secondaryCircleSize: "13px",
    secondaryCirclePadding: "xsmall"
  },
  medium: {
    widthAndHeight: "48px",
    imageSize: "32px",
    insetAndBorderWidth: "xxsmall",
    secondaryCircleSize: "18px",
    secondaryCirclePadding: "small"
  },
  large: {
    widthAndHeight: "64px",
    imageSize: "44px",
    insetAndBorderWidth: "xxsmall",
    secondaryCircleSize: "26px",
    secondaryCirclePadding: "medium"
  }
};
